import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { AuthCallbackError } from './app/core/auth/providers/auth-provider';
import { handleOAuthPopupCallback } from './oauth-popup-callback';

function renderSignInError(error: AuthCallbackError) {
  const container = document.createElement('div');
  container.style.cssText =
    'font-family: Roboto, sans-serif; margin: 48px auto; max-width: 480px; text-align: center;';
  const heading = document.createElement('h2');
  heading.textContent = 'Sign-in failed';
  const detail = document.createElement('p');
  detail.textContent = error.description ?? error.error;
  const retry = document.createElement('a');
  retry.href = '/';
  retry.textContent = 'Try again';
  container.append(heading, detail, retry);
  document.body.appendChild(container);
}

if (!handleOAuthPopupCallback()) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => {
      if (err instanceof AuthCallbackError) {
        renderSignInError(err);
      } else {
        console.error(err);
      }
    });
}
